export const MarketplaceFilter: {
	[key: string]: {
		en: string
		th: string
		value: any
	}
} = {
	all: {
		en: 'All',
		th: 'ทั้งหมด',
		value: 'all',
	},
	pendingPayment: {
		en: 'Pending Payment',
		th: 'รอชำระเงิน',
		value: 'pendingPayment',
	},
	pendingDelivery: {
		en: 'Pending Delivery',
		th: 'รอจัดส่ง',
		value: 'pendingDelivery',
	},
	onDeliver: {
		en: 'On Deliver',
		th: 'การจัดส่ง',
		value: 'onDeliver',
	},
	delivered: {
		en: 'Delivered',
		th: 'จัดส่งแล้ว',
		value: 'delivered',
	},
	cancelled: {
		en: 'Cancelled',
		th: 'ยกเลิก',
		value: 'cancelled',
	},
	refundAndReturn: {
		en: 'Refund/Return',
		th: 'การคืนเงิน/สินค้า',
		value: 'refundAndReturn',
	},
	deliverFailed: {
		en: 'Delivery Failed',
		th: 'จัดส่งไม่สำเร็จ',
		value: 'deliverFailed',
	},
}
